import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { Instagram, InstagramProps } from './Instagram';

export interface StandaloneInstagramProps extends StandaloneComponentProps {
  postId: string;
  options?: Omit<InstagramProps, 'postId'>;
  hidecaption?: boolean;
}

export const StandaloneInstagram: StandaloneComponent<StandaloneInstagramProps> = ({ postId, options, ...props }) => {
  return <Instagram postId={postId} {...options} {...props} />;
};

export default StandaloneInstagram;
